import React, { useRef, useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const RevealComponent = ({ children , delay }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  // Set up animation variants
  const variants = {
    hidden: { opacity: 0, translateY: '100px' },
    visible: { opacity: 1, translateY: '0' },
  };

  // Set up animation transition
  const transition = {
    duration: 0.5,
    ease: 'easeInOut',
    delay : delay
  };

  // Update animation controls when inView changes
  // Update animation controls when inView changes
    useEffect(() => {
        if (!inView) {
        controls.start('hidden');
        } else {
        controls.start('visible');
        }
  }, [controls, inView]);
  

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={variants}
      transition={transition}
    >
      {children}
    </motion.div>
  );
};

export default RevealComponent;
